<template>
  <b-container class="my-4">
    <h2 class="mb-4">Crear misión con código</h2>

    <b-card>
      <b-row>
        <b-col md="6" class="mb-3">
          <label>Título</label>
          <b-form-input v-model="form.title" placeholder="Título de la misión" />
        </b-col>
        <b-col md="6" class="mb-3">
          <label>Enlace</label>
          <b-form-input v-model="form.link" placeholder="https://..." />
        </b-col>
        <b-col md="12" class="mb-3">
          <label>Descripción</label>
          <b-form-textarea v-model="form.description" rows="2" />
        </b-col>
        <b-col md="6" class="mb-3">
          <label>Servicio (opcional)</label>
          <b-form-select v-model="form.service">
            <b-form-select-option :value="''">Ninguno</b-form-select-option>
            <b-form-select-option
              v-for="s in services"
              :key="s.id"
              :value="s.title"
              >{{ s.title }}</b-form-select-option
            >
          </b-form-select>
        </b-col>
      </b-row>

      <hr />
      <label class="font-weight-bold">Recompensas</label>
      <b-row v-for="(reward, i) in form.rewards" :key="i" class="mb-2 align-items-end">
        <b-col md="6">
          <label>Servicio</label>
          <b-form-select v-model="reward.field" @change="setRewardName(reward)">
            <b-form-select-option
              v-for="s in rewardServices"
              :key="s.field"
              :value="s.field"
              >{{ s.label }}</b-form-select-option
            >
          </b-form-select>
        </b-col>
        <b-col md="4">
          <label>Cantidad</label>
          <b-form-input v-model.number="reward.uses" type="number" min="0" />
        </b-col>
        <b-col md="2">
          <b-button variant="outline-danger" @click="form.rewards.splice(i, 1)"
            >Quitar</b-button
          >
        </b-col>
      </b-row>
      <b-button size="sm" variant="outline-primary" @click="addReward"
        >+ Agregar recompensa</b-button
      >

      <hr />
      <b-form-checkbox v-model="form.use_code" class="mb-2">
        Usar código promocional (las recompensas se canjean con el código)
      </b-form-checkbox>
      <b-row v-if="form.use_code">
        <b-col md="6" class="mb-3">
          <label>Código (opcional, máx. 9 caracteres)</label>
          <b-form-input
            v-model="form.code"
            maxlength="9"
            placeholder="Dejar vacío para generar uno"
          />
        </b-col>
        <b-col md="6" class="mb-3">
          <label>Vigencia hasta (opcional)</label>
          <b-form-input v-model="form.expiration_date" type="date" />
          <small class="text-muted">
            Con fecha, la misión es una campaña: pasada esa fecha el código deja
            de canjearse. Sin fecha, queda abierta para siempre.
          </small>
        </b-col>
      </b-row>

      <b-button v-if="!saved" variant="primary" :disabled="saving" @click="save">
        {{ saving ? "Guardando..." : "Crear misión" }}
      </b-button>

      <b-alert v-if="saved" show variant="success" class="mt-3">
        <p class="mb-2">
          Misión creada.
          <span v-if="createdCode">
            Código para canjear: <strong>{{ createdCode }}</strong>
          </span>
        </p>
        <b-button variant="primary" class="mr-2" @click="createAnother"
          >Crear otra misión</b-button
        >
        <b-button variant="outline-secondary" @click="goToUtopie"
          >Volver a Utopie</b-button
        >
      </b-alert>
    </b-card>
  </b-container>
</template>

<script>
import missionService from "../../../services/missionService";

// Reward targets = the service uses fields the redeem endpoint understands.
const REWARD_SERVICES = [
  { field: "planifications_uses", label: "Planificaciones" },
  { field: "materials_uses", label: "Materiales" },
  { field: "documents_uses", label: "Documentos" },
  { field: "tests_uses", label: "Corrección de Tests" },
  { field: "eureka_uses", label: "Eureka" },
];

export default {
  created() {
    missionService.getServices().then((data) => {
      this.services = data;
    });
  },
  data() {
    return {
      rewardServices: REWARD_SERVICES,
      services: [],
      saving: false,
      saved: false,
      createdCode: "",
      form: {
        title: "",
        description: "",
        link: "",
        service: "",
        rewards: [],
        use_code: false,
        code: "",
        expiration_date: "",
      },
    };
  },
  methods: {
    setRewardName(reward) {
      const s = REWARD_SERVICES.find((x) => x.field === reward.field);
      reward.name = s ? s.label : "";
    },
    addReward() {
      const s = REWARD_SERVICES[0];
      this.form.rewards.push({ field: s.field, name: s.label, uses: 1 });
    },
    createAnother() {
      this.form = {
        title: "",
        description: "",
        link: "",
        service: "",
        rewards: [],
        use_code: false,
        code: "",
        expiration_date: "",
      };
      this.createdCode = "";
      this.saved = false;
    },
    goToUtopie() {
      if (this.$router.history.base === "/utopie")
        this.$router.push({ name: "home" });
      else window.location.href = "/utopie#/";
    },
    save() {
      if (!this.form.title) {
        this.$toasted.error("El título es obligatorio.");
        return;
      }
      this.saving = true;
      this.createdCode = "";
      missionService
        .createWithCode(this.form)
        .then((data) => {
          this.createdCode = data.code;
          this.saved = true;
          this.$toasted.success("Misión creada");
        })
        .catch((error) => {
          this.$toasted.error(
            (error.response && error.response.data.message) ||
              "No se pudo crear la misión"
          );
        })
        .finally(() => {
          this.saving = false;
        });
    },
  },
};
</script>
